const initialBrandTarget = {
  brandTargets : [],
  brandTargetmessages:{}
};

const BrandTargetReducer = (brandTarget = initialBrandTarget, action) => {
  switch (action.type) {
      case 'GET_BRANDTARGET':
        return {
          ...brandTarget, brandTargets: action.payload.data
      };
      case 'ADD_BRANDTARGET':
        return {
          ...brandTarget, brandTargetmessages: action.payload.data
      };
      case 'UPDATE_BRANDTARGET':
        return {
          ...brandTarget, brandTargetmessages: action.payload.data
      };
      
        default:
          return brandTarget;
  }
}
export default BrandTargetReducer;